import { Component } from 'react';
import { Button, Container, Col, Row, Form } from 'react-bootstrap'
import { connect } from "react-redux";
import TextField from "../common/form/TextField.js";
import translations from "../../config/translation/alert_entry_translations.json"

import { LOADING_STATUES } from "../constants/constants";


const mapStateToProps = state => {
  return {
    language: state.languageReducer ? state.languageReducer : 'ENGLISH',
    currentUser: state.currentUserReducer,
    translations: state.translationsReducer
  };
}

const matchDispatchToProps = (dispatch) => {
  return {
    handleLockout: (lockout) => dispatch({ type: 'SET_LOCKOUT_IN_PLACE', lockout })
  }
}

class AlertEntryEmailRow extends Component {

  state = {
    selectedId: '',
    selectedAlertName: '',
    showDeleteConfirmationDialog: false,
    loadingStatus: "",
    errors: {}
  }

  showLoading = () => {
    if (this.state.loadingStatus === "") {
      this.setState({
        loadingStatus: LOADING_STATUES.LOADING
      })
      return true;
    }
    return false;
  }

  hideLoading = (message, status) => {
    if (status === 'ERROR') {
      this.setState({
        loadingStatus: "",
        submitMessage: ""
      })
    } else {
      this.setState({
        loadingStatus: "",
        submitMessage: message
      })
    }
  }

  render() {

    let disableField = this.props.emailAddress.saved;

    let verifiedBadge = <span></span>;
    let resendButton =  <></>;
    let resendMessage = translations[this.props.language].modify_recipient_hint 
    if (disableField) {
      if (this.props.emailAddress.verified === true) {
        verifiedBadge = <span className='badge bg-success-darker text-light'>{translations[this.props.language].email_verified}</span>;
      } else {
        verifiedBadge = <span className='badge bg-warning text-dark'>{translations[this.props.language].verification_needed}</span>;
        resendButton = <Button key={'emailResend' + this.props.index} variant="secondary" id={'emailResend' + this.props.index} onClick={this.props.onResend}>{translations[this.props.language].resend}</Button>;
        resendMessage = translations[this.props.language].resend_email_hint
      }
    }

    let acknowledgement = this.props.acknowledgement;
    if (!this.props.language || this.props.language !== 'ENGLISH' ) {
      acknowledgement = this.props.translations.emailAcknowledgement;
    }

    return (
      <>
        <fieldset className="borderthick p-2 field_set" name={this.props.alertName} style={{ marginRight: 10 }} >
          <legend className="float-none w-auto" style={{ fontSize: '1rem', margin: 0, }} >{translations[this.props.language].email_recipient} {this.props.index + 1}</legend>
          <Row style={{ paddingBottom: 10 }}>
            <Col style={{ paddingLeft: 0 }} lg={12} md={12} sm={12} xs={12}>
              <Container name={this.props.alertName}>
                <Row>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    {verifiedBadge}
                  </Col>
                  <Col className='text-right' style={{ padding: 0 }} lg={6} md={6} sm={6} xs={6}>
                    <Button variant="link" key={'emailDelete' + this.props.index} id={'emailDelete' + this.props.index} style={{ paddingTop: 0 }} onClick={this.props.onDelete}><strong>- {translations[this.props.language].remove}</strong></Button>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} md={6} sm={9} xs={9}>
                    <Form.Group controlId={'emailEntry' + this.props.index} style={{ marginBottom: 0 }} >
                      <TextField formGroup={{ label: translations[this.props.language].email_address, fieldType: 'email', labelFor: 'emailEntry' + this.props.index, value: this.props.emailAddress.value, primaryCriteria: true, placeholder: ' ', disableField }} onChange={this.props.onChange} />
                      <div style={{ color: "red", fontWeight: "bold" }}> {this.props.errors['email' + this.props.index]}</div>
                    </Form.Group>
                  </Col>
                  <Col style={{ paddingLeft: 0 }} lg={3} md={3} sm={2} xs={2}>
                    <div>&nbsp;</div>
                    {
                      !disableField &&
                      <Button key={'emailLookup' + this.props.index} variant="primary" id={'emailLookup' + this.props.index} onClick={this.props.onClick}>{translations[this.props.language].lookup}</Button>
                    }
                    { resendButton }
                  </Col>
                </Row>
                <Row>
                  {
                    !disableField &&
                    <Col style={{ fontSize: '0.875em', marginLeft: 3 }} >
                      {translations[this.props.language].enter_email_hint }
                    </Col>
                  }
                  {
                    disableField &&
                    <Col style={{ fontSize: '0.875em', marginLeft: 3 }} >
                      {resendMessage}
                    </Col>
                  }
                </Row>
                <Row>&nbsp;</Row>
                {
                  !disableField &&
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      {/* checkbox is tricky.  This is the only way I could make the checked attribute works.  It's essentially forcing the checkbox to re-render. */}
                      {
                        this.props.emailAddress.acknowledged && 
                        <Form.Check key={'emailAcknowledgeChecked' + this.props.index} id={'emailAcknowledge' + this.props.index} type='checkbox' checked={true} onChange={this.props.onChange} label={acknowledgement} />
                      }
                      {
                        !this.props.emailAddress.acknowledged && 
                        <Form.Check key={'emailAcknowledgeUnchecked' + this.props.index} id={'emailAcknowledge' + this.props.index} type='checkbox' checked={false} onChange={this.props.onChange} label={acknowledgement} />
                      }
                      <div style={{ color: "red", fontWeight: "bold" }}> {this.props.errors['emailAcknowledged' + this.props.index]}</div>
                    </Col>
                  </Row>
                }
              </Container>
            </Col>
          </Row>
        </fieldset>

      </>
    )
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(AlertEntryEmailRow);